import React from 'react';
import classnames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
function isImage(nStr) {
  return nStr.startsWith('data:') || nStr.startsWith('http:') || nStr.startsWith('https:') || nStr.endsWith('.png') || nStr.endsWith('.jpg') || nStr.endsWith('.gif') || nStr.endsWith('.svg');
}
function isImageOptsZero(imgOpts) {
  if (imgOpts == null) {
    return false;
  }
  if (imgOpts.width === 0 || imgOpts.height === 0 || imgOpts.width === '0' || imgOpts.height === '0') {
    return true;
  }
  return false;
}
function create(str, imgOpts, iconOpts, theme) {
  let nStr = str;
  if (nStr == null) {
    return null;
  }
  if (typeof nStr === 'function') {
    nStr = nStr();
  }
  if (typeof nStr === 'string') {
    if (nStr.startsWith('@icon:') && theme && theme.resources) {
      nStr = theme.resources('icon', nStr.substring(6));
    }
    if (nStr == null) {
      return null;
    }
    if (isImage(nStr)) {
      if (isImageOptsZero(imgOpts)) {
        return null;
      }
      return /*#__PURE__*/_jsx("img", {
        src: nStr,
        ...imgOpts
      }); // eslint-disable-line
    }
    if (iconOpts && iconOpts.style && (iconOpts.style.fontSize === 0 || iconOpts.style.fontSize === '0px')) {
      return null;
    }
    return /*#__PURE__*/_jsx("i", {
      ...iconOpts,
      className: classnames(nStr, iconOpts?.className)
    });
  }
  return nStr;
}

/**
 * This will return the first not undefined value in order of
 * uIconSpec, uIcon, iconSpec, icon. This used to allow the the 
 * toggle actions to show the right icon if only icon is set, but
 * the theme has default iconOn/iconOff values.
 */
function selectIcon(uIconSpec, uIcon, iconSpec, icon) {
  if (uIconSpec !== undefined) {
    return uIconSpec;
  }
  if (uIcon !== undefined) {
    return uIcon;
  }
  if (iconSpec !== undefined) {
    return iconSpec;
  }
  return icon;
}
export default {
  create,
  selectIcon
};